import React from 'react';
import cn from 'classnames';
import { CheckmarkMIcon } from '@alfalab/icons-glyph/CheckmarkMIcon';

var styles = {"checkmark":"select__checkmark_1qan6","selected":"select__selected_1qan6","displayIcon":"select__displayIcon_1qan6","displayBadge":"select__displayBadge_1qan6"};
require('./index.css')

var Checkmark = function (_a) {
    var _b;
    var selected = _a.selected, className = _a.className;
    return (React.createElement("div", { className: cn(styles.checkmark, className, (_b = {},
            _b[styles.selected] = selected,
            _b)) },
        React.createElement(CheckmarkMIcon, { className: styles.displayIcon })));
};

export { Checkmark };
